import { __assign, __extends, __rest } from "tslib";
import cn from 'classnames';
import React, { PureComponent } from 'react';
import b_ from 'b_';
import snakeCase from 'lodash/snakeCase';
import isType from '../utils/isType';
import './index.styl';
var b = b_.with('amber-icon');
export default function iconFactory(Icon, name) {
    var _a;
    return _a = (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_1.prototype.render = function () {
                var _a;
                var _b = this.props, className = _b.className, valign = _b.valign, rest = __rest(_b, ["className", "valign"]);
                var finalClassName = cn(b((_a = { valign: valign }, _a[snakeCase(name || '')] = !!name, _a)), className);
                return (React.createElement("span", { className: finalClassName },
                    React.createElement(Icon, __assign({}, rest))));
            };
            return class_1;
        }(PureComponent)),
        _a.displayName = 'Icon',
        _a;
}
export function isIcon(child) {
    return isType(child, 'Icon');
}
//# sourceMappingURL=index.js.map